import { render, staticRenderFns } from "./releaseMsg.vue?vue&type=template&id=ca320062&scoped=true"
import script from "./releaseMsg.vue?vue&type=script&lang=js"
export * from "./releaseMsg.vue?vue&type=script&lang=js"
import style0 from "./releaseMsg.vue?vue&type=style&index=0&id=ca320062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca320062",
  null
  
)

export default component.exports